import { SortItem } from './member.dashboard.license.response';
import { InvoiceItem } from '../../domain/invoice.item';
import { Invoice } from '../../domain/invoice';

export class AutomationBillingHistoryItem {
    ID: number;
    LineNumber: number;
    MemberName: string;
    DesignerName: string;
    LicenseKey: string;
    Processed: string;
    Result: string;
    Action: string;
    RoutineName: string;
    DateTimeCreated: Date;
    BillingDateTime: Date;
    License_ID: number;
    Member_ID: number;
    Invoice_ID: number;
    Invoice: Invoice;

    public static FixDates(item: AutomationBillingHistoryItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.BillingDateTime = new Date(item.BillingDateTime);
    }

}

export class AutomationBillingHistoryItemArray extends Array<AutomationBillingHistoryItem> {
    public LastSort: SortItem;

    constructor(...items: AutomationBillingHistoryItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AutomationBillingHistoryItemArray.prototype);
    }

    public static FixDates(item: AutomationBillingHistoryItemArray) {
        item.forEach(x => AutomationBillingHistoryItem.FixDates(x));
    }


}
